import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import jwt_decode from 'jwt-decode';
import { ChatService } from 'src/app/services/chat.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from 'src/app/services/functions.service';
import { StatusModalComponent } from 'src/app/generic-components/status-modal/status-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ReassignAlertComponent } from '../reassign-alert/reassign-alert.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { aggressor } from 'src/app/models/aggressorModel';

declare var Geofence;
var mapProperties;
var geofence;
var mapAlert:google.maps.Map;

@Component({
  selector: 'app-view-alert',
  templateUrl: './view-alert.component.html',
  styleUrls: ['./view-alert.component.css'],
  providers: [NgxSpinnerService]
})
export class ViewAlertComponent implements OnInit {
  @ViewChild('aggressorDetailsModal') aggressorDetailsModal!: TemplateRef<any>;
  chatMessages:Array<any>;
  alertCreatedBy:string;
  selectedAlert:any = null;
  userId: any;
  role: any;
  expired: any;
  conversationId:string;
  attending = false;
  alertTriggered = "";
  profile:Object = {};
  user_msg:string;
  timer:any;
  alertTimer: any;
  messages:any = null;
  msg_count = 0;
  documents:any;
  videos:any;
  latLngList = [];
  agentLatLngList = [];
  currentPosition = [];
  agentCurrentPosition = [];
  lineList = [];
  linePath:any;
  agentLineList = [];
  agentLinePath:any;
  positionAmount: number = 20;
  markersList: google.maps.Marker[] = [];
  agentMarkersList: google.maps.Marker[] = [];
  alertTypes:any;
  textColor = "text-dark";
  alertId:number = 0;
  mapElementAlert: any;
  marker:any;
  agentMarker:any;
  alertTypeName:any;
  fieldOption: any;
  c_fields: any;
  timeDifference: any;
  attendTime:any;
  closeTime:any;
  totalTime: any;
  seconds: any;
  minutes: any;
  hours: any;
  days: any;
  clock: any;
  lateTimer: any;
  geoAssignment:any;
  unsubscribe: any;
  unattendedLateCanceled: boolean = false;
  finalLatitude: any;
  finalLongitude: any;
  aggressors: aggressor[] = [];
  selectedAggressor: aggressor = null;

  constructor(private apiService: ApiService,
    private angularFireStore: AngularFirestore,
    private chatService: ChatService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private translate: TranslateService,
    public functionsService:FunctionsService,
    private router: Router,
    private route: ActivatedRoute,
    public alertService: AlertService) {
        this.functionsService.setTitle('breadcrumb.view-alert');
        this.route.params.subscribe(params => {
            if(this.alertId && this.alertId != params['alertId']){
                this.alertId = params['alertId'];
                this.ngOnInit();
            }
            this.alertId = params['alertId'];
        });
    }

  async ngOnInit(){
    this.userId = await this.functionsService.getUserId();
    this.expired = await this.functionsService.isExpired();
    this.role = await this.functionsService.getRole();
    this.alertService.alertStatus = 0;
    this.modalService.dismissAll();
    this.getUserFieldOption();
    this.fetchAlert(this.alertId);
    this.fetchPreconfiguredMessages();
    
    this.clock = setInterval(()=>{
        const d = new Date();
        this.lateTimer = d.getTime()
    }, 1000)
    this.alertTimer = setInterval(() => {
        if (this.alertService.alertStatus != 3) {
            this.calculateAlertTimer();
        }
        else{
            var attendTime = this.selectedAlert?.attendTime? this.selectedAlert?.attendTime:"00:00";
            var times = attendTime.split(':');
            var milliseconds = times[0] * 3600000 + times[1] * 60000;
            this.unattendedLateCanceled = new Date(this.alertService.canceledDate).getTime() > (new Date(this.selectedAlert?.createdDate).getTime() + milliseconds);
            clearInterval(this.alertTimer);
        }
    }, 1000)
  }  

  calculateAlertTimer(){
    var currentDate = new Date();
    var offset = new Date().getTimezoneOffset();
    offset = offset * 60000;
    this.timeDifference = this.selectedAlert?.timerStatus && (this.selectedAlert?.timerStatus == 1 || this.selectedAlert?.timerStatus == 2) ?  (new Date(this.selectedAlert?.canceledDate).getTime() - new Date(this.selectedAlert?.createdDate).getTime()) : (currentDate.getTime() - new Date(this.selectedAlert?.createdDate).getTime()) + offset;
    this.seconds = Math.floor((this.timeDifference)/ 1000);
    this.minutes = Math.floor(this.seconds / 60);
    this.hours = Math.floor(this.minutes / 60);
    this.days = Math.floor((this.hours) / 24);

    this.hours = this.hours - (this.days * 24);
    this.minutes = this.minutes - (this.days*24*60) - (this.hours*60);
    this.seconds = this.seconds - (this.days*24*60*60) - (this.hours*60*60) - (this.minutes*60);

    this.seconds = this.seconds < 10 ? "0" + this.seconds : this.seconds;
    this.minutes = this.minutes < 10 ? "0" + this.minutes : this.minutes;
    this.hours = this.hours < 10 ? "0" + this.hours : this.hours;

    this.totalTime = this.hours + ":" + this.minutes + ":" + this.seconds;
  }

  fetchAlert(id, refresh = false){
    this.spinner.show();
    this.apiService.getAlert(id).subscribe(
        data => {
            this.geoAssignment = JSON.parse(localStorage.getItem('geoAssignment'));
            this.selectedAlert = data;
            if(this.selectedAlert["status"] == 1){
                this.router.navigateByUrl('/main/alertHistory/view-alert-history/' + id);
            }
            this.alertService.alertStatus = this.selectedAlert["status"];
            this.alertService.canceledDate = this.selectedAlert["canceledDate"];
            this.alertTypeName = this.selectedAlert.alertTypeName;
            this.loadAggressors(this.selectedAlert.createdBy);
            this.calculateAlertTimer();
            if(!refresh){this.viewAlert();}
            this.spinner.hide();
        },
        error => {
            this.spinner.hide();
            this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  fetchPreconfiguredMessages() {
    this.apiService.getPreconfiguredMessages().subscribe(resp => {
        this.messages = resp;
        this.msg_count = Object.keys(this.messages).length;
    }, error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
    });
  }

  viewAlert() {
    //Get alert info
    mapProperties = {
        mapId: 'mapAlert#'+this.selectedAlert["id"], 
        zoom: 20,
        mapTypeId: google.maps.MapTypeId.HYBRID,
        mapTypeControl: true,
        rotateControl: false,
        disableDefaultUI: true, 
        zoomControl: true,
        scaleControl: true, 
        streetViewControl: true, 
        fullscreenControl: true,
        tilt: 0
    };
    this.fetchAlertTypes();
    this.apiService.getOrgZones().subscribe(
        data => {
            if(data!=null){
                initMap(data);
            }
            else{
                mapAlert = new google.maps.Map(this.mapElementAlert.nativeElement, mapProperties);
            }
            this.fetchAlertInfo();
        }
    );
  } 

  async fetchAlertInfo(){
    this.alertCreatedBy = `${this.selectedAlert.createdBy}`;
    this.chatMessages = [];
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 15000);
    if((this.alertService.alertStatus == 0 || this.alertService.alertStatus == 2 || this.alertService.alertStatus == 4 || this.alertService.alertStatus == 6 || this.alertService.alertStatus == 7) && (this.selectedAlert["attendedBy"] != this.userId)){ 
        this.attending = false;
    }else if((['Owner','SecurityAgent','Supervisor'].includes(this.role)) && 
             (this.selectedAlert["createdBy"]!=this.userId))
    { this.attending = true;}
    this.apiService.getProfile(this.selectedAlert.createdBy).subscribe(
        data => {
            this.profile = data;
            this.getUserFields();
            if(this.selectedAlert.status != 0 && this.selectedAlert.status != 7){
                if(document.getElementById("alert-log")){document.getElementById("alert-log").hidden = false;}
            }
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
        }
    );

    this.apiService.getDocuments(this.selectedAlert.createdBy)
        .subscribe(resp => {
            this.documents = resp;
        }, err => {
            console.error(err);
        });
    
    //Get chat data (if any)
    this.conversationId = this.selectedAlert.id.toString();
    let messages$: any = this.angularFireStore
        .collection<firebase.default.firestore.DocumentData>(`${environment.firebaseConfig.path}/${this.conversationId}/Messages`).valueChanges();
    this.unsubscribe = messages$.pipe(
        map((chat: any[]) => {
            chat.forEach(c => c.timestamp = c.timestamp * 1000);
            return chat.sort((a, b) => (a.timestamp > b.timestamp) ? 1 : -1);
        })
    ).subscribe(chat => {
        this.chatMessages = chat;
        this.spinner.hide();
    });

    //Initialize map

    this.apiService.getAlertPositions(this.selectedAlert.id, this.positionAmount, 0).subscribe(
        data => {
            let jsonString = JSON.stringify(data);
            let jsonObject = JSON.parse(jsonString);
            if(jsonObject[0].length > 0 && this.markersList.length < 1){
                var iconColor = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                for(var i=0;i<jsonObject[0].length;i++){
                    this.recenter_map(jsonObject[0][i]?.latitude,jsonObject[0][i]?.longitude);
                    this.latLngList.push(new google.maps.LatLng(jsonObject[0][i]?.latitude,jsonObject[0][i]?.longitude));
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(jsonObject[0][i]?.latitude, jsonObject[0][i]?.longitude),
                        draggable: false,
                        map: mapAlert,
                        icon: {
                            url: iconColor
                        },
                    });
                    this.markersList.push(marker);
                    this.markersList[i].setMap(mapAlert);
    
                    if(i > 0){
                        this.linePath = new google.maps.Polyline({
                            path: [this.latLngList[i - 1], this.latLngList[i]],
                            map: mapAlert,
                            geodesic: true,
                            strokeColor: 'black'
                        });
                        this.lineList.push(this.linePath);
                        this.lineList[i - 1].setMap(mapAlert);
                    }
                }
            
                if(this.alertService.alertStatus == 3 || this.alertService.alertStatus==4){
                    this.finalLatitude = jsonObject[0][jsonObject.length - 1]?.latitude;
                    this.finalLongitude = jsonObject[0][jsonObject.length - 1]?.longitude;
                }

                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(jsonObject[0][jsonObject[0].length - 1]?.latitude, jsonObject[0][jsonObject[0].length - 1]?.longitude),
                    draggable: false,
                    map: mapAlert,
                    icon: {
                        url: this.finalLatitude && this.finalLongitude ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png" : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                    },
                });
                this.currentPosition.push(marker);
                this.currentPosition[0].setMap(mapAlert);
            }
            else{
                this.recenter_map(this.selectedAlert["initialLatitude"], this.selectedAlert["initialLongitude"]);
                this.latLngList.push(new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude));
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude),
                    draggable: false,
                    map: mapAlert,
                    icon: {
                      url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                    }
                });
                
                this.markersList.push(marker);
                this.markersList[0].setMap(mapAlert);

                if(this.alertService.alertStatus == 3 || this.alertService.alertStatus==4){
                    this.finalLatitude = this.selectedAlert.initialLatitude;
                    this.finalLongitude = this.selectedAlert.initialLongitude;
                }
                
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude),
                    draggable: false,
                    map: mapAlert,
                    icon: {
                        url: this.finalLatitude && this.finalLongitude ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png" : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                    },
                });
                this.currentPosition.push(marker);
                this.currentPosition[0].setMap(mapAlert);
            }
            if(jsonObject[1].length > 0 && [2,4].includes(this.alertService.alertStatus) && this.agentMarkersList.length < 1){
                var agentIconColor = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                for(var i=0;i<jsonObject[1].length;i++){
                    this.recenter_map(jsonObject[1][i]?.latitude,jsonObject[1][i]?.longitude);
                    this.agentLatLngList.push(new google.maps.LatLng(jsonObject[1][i]?.latitude,jsonObject[1][i]?.longitude));
                    var agentMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(jsonObject[1][i]?.latitude, jsonObject[1][i]?.longitude),
                        draggable: false,
                        map: mapAlert,
                        icon: {
                            url: agentIconColor
                        },
                    });
                    this.agentMarkersList.push(agentMarker);
                    this.agentMarkersList[i].setMap(mapAlert);
    
                    if(i > 0){
                        this.agentLinePath = new google.maps.Polyline({
                            path: [this.agentLatLngList[i - 1], this.agentLatLngList[i]],
                            map: mapAlert,
                            geodesic: true,
                            strokeColor: 'black'
                        });
                        this.agentLineList.push(this.agentLinePath);
                        this.agentLineList[i - 1].setMap(mapAlert);
                    }
                }
            
                agentMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(jsonObject[1][jsonObject[1].length - 1]?.latitude, jsonObject[1][jsonObject[1].length - 1]?.longitude),
                    draggable: false,
                    map: mapAlert,
                    icon: {
                        url: "https://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                    },
                });
                this.agentCurrentPosition.push(marker);
                this.agentCurrentPosition[0].setMap(mapAlert);
            }
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
        }
    );
    this.alertTriggered = this.selectedAlert.createdDate;
    
    if(this.alertService.alertStatus == 0 || this.alertService.alertStatus == 2){
        this.timer = setInterval(() => {
            if(this.markersList.length > 19){
            this.markersList[0].setMap(null);
            this.lineList[0].setMap(null);
            this.markersList = this.markersList.slice(1);
            this.lineList = this.lineList.slice(1);
            }
            if(this.currentPosition.length > 0){
                this.currentPosition.forEach(marker => {
                    marker.setMap(null);
                });
                this.currentPosition = [];
            }
            if(this.agentMarkersList.length > 19){
                this.agentMarkersList[0].setMap(null);
                this.agentLineList[0].setMap(null);
                this.agentMarkersList = this.agentMarkersList.slice(1);
                this.agentLineList = this.agentLineList.slice(1);
            }
            if(this.agentCurrentPosition.length > 0){
                this.agentCurrentPosition.forEach(marker => {
                    marker.setMap(null);
                });
                this.agentCurrentPosition = [];
            }
            this.apiService.getLatestPositionAlert(this.selectedAlert.id).subscribe(
            async data => {                    let jsonString = JSON.stringify(data);
                    let jsonObject = JSON.parse(jsonString);
                    var iconColor = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                    var agentIconColor = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                    if(jsonObject[0] != null){
                        this.alertService.alertStatus = jsonObject[0].alertStatus;
                        switch(this.alertService.alertStatus){
                            case 1:
                                this.attending = false;
                                if(document.getElementById("attend#"+this.selectedAlert?.id)){document.getElementById("attend#"+this.selectedAlert?.id).hidden = true;}
                                if(document.getElementById("write_msg#"+this.selectedAlert?.id)){document.getElementById("write_msg#"+this.selectedAlert?.id).hidden = true;}
                                if(document.getElementById("msg_send_btn#"+this.selectedAlert?.id)){document.getElementById("msg_send_btn#"+this.selectedAlert?.id).hidden = true;}
                            if(['Owner','Supervisor'].includes(this.role)){ 
                                if(document.getElementById("reassign_alert#"+this.selectedAlert?.id)){document.getElementById("reassign_alert#"+this.selectedAlert?.id).hidden = true;}
                                    clearInterval(this.timer);
                                }
                                break;
                            case 2:
                            if(jsonObject[0].alertAttendedBy != this.userId){
                                this.attending=false;
                                    if(document.getElementById("attend#"+this.selectedAlert?.id)){document.getElementById("attend#"+this.selectedAlert?.id).hidden = true;}
                                    if(document.getElementById("write_msg#"+this.selectedAlert?.id)){document.getElementById("write_msg#"+this.selectedAlert?.id).hidden = true;}
                                    if(document.getElementById("msg_send_btn#"+this.selectedAlert?.id)){document.getElementById("msg_send_btn#"+this.selectedAlert?.id).hidden = true;}
                                }else {
                                    this.attending=true;
                                    if(document.getElementById("attend#"+this.selectedAlert?.id)){document.getElementById("attend#"+this.selectedAlert?.id).hidden = true;}
                                    if(document.getElementById("write_msg#"+this.selectedAlert?.id)){document.getElementById("write_msg#"+this.selectedAlert?.id).hidden = false;}
                                    if(document.getElementById("msg_send_btn#"+this.selectedAlert?.id)){document.getElementById("msg_send_btn#"+this.selectedAlert?.id).hidden = false;}
    
                                }
                            if(['Owner','Supervisor'].includes(this.role)){
                                if(document.getElementById("reassign_alert#"+this.selectedAlert?.id)){document.getElementById("reassign_alert#"+this.selectedAlert?.id).hidden = false;}
                                }
                                break;
                            case 3:
                                if((['Owner','SecurityAgent','Supervisor'].includes(this.role))&&
                                    (this.selectedAlert["createdBy"]!=this.userId)){
                                    this.attending = true;
                                }
                                iconColor = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
                                agentIconColor = "https://maps.google.com/mapfiles/ms/icons/orange-dot.png";
                                this.finalLatitude = jsonObject[0][jsonObject.length - 1]?.latitude;
                                this.finalLongitude = jsonObject[0][jsonObject.length - 1]?.longitude;
                                clearInterval(this.timer);
                                break;
                            case 4:
                            if(jsonObject[0].alertAttendedBy == this.userId){
                                this.attending = true;
                                }
                                iconColor = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
                                agentIconColor = "https://maps.google.com/mapfiles/ms/icons/orange-dot.png";
                                this.finalLatitude = jsonObject[0][jsonObject.length - 1]?.latitude;
                                this.finalLongitude = jsonObject[0][jsonObject.length - 1]?.longitude;
                                clearInterval(this.timer);
                                break;
                            default:
                                break;
                        }
                        this.recenter_map(jsonObject[0]?.latitude,jsonObject[0]?.longitude);
                        this.latLngList.push(new google.maps.LatLng(jsonObject[0]?.latitude,jsonObject[0]?.longitude));
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(jsonObject[0]?.latitude, jsonObject[0]?.longitude),
                            draggable: false,
                            map: mapAlert,
                            icon: {
                                url: iconColor
                            },
                        });
                        this.markersList.push(marker);
                        this.markersList[this.markersList.length - 1].setMap(mapAlert);

                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(jsonObject[0]?.latitude, jsonObject[0]?.longitude),
                            draggable: false,
                            map: mapAlert,
                            icon: {
                                url: this.finalLatitude && this.finalLongitude ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png" : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                            },
                        });
                        this.currentPosition.push(marker);
                        this.currentPosition[0].setMap(mapAlert);
                        if(this.latLngList.length > 1){
                            this.linePath = new google.maps.Polyline({
                                path: [this.latLngList[this.latLngList.length - 2],this.latLngList[this.latLngList.length - 1]],
                                map: mapAlert,
                                geodesic: true,
                                strokeColor: 'black'
                            });
                            this.lineList.push(this.linePath)
                            this.lineList[this.lineList.length - 1].setMap(mapAlert);
                        }
                    }   
                    else{
                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude),
                            draggable: false,
                            map: mapAlert,
                            icon: {
                                url: this.finalLatitude && this.finalLongitude ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png" : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                            },
                        });
                        this.currentPosition.push(marker);
                        this.currentPosition[0].setMap(mapAlert);
                    }
                    if(jsonObject[1] && [2,4].includes(this.alertService.alertStatus)){
                        this.agentLatLngList.push(new google.maps.LatLng(jsonObject[1]?.latitude,jsonObject[1]?.longitude));
                            var agentMarker = new google.maps.Marker({
                            position: new google.maps.LatLng(jsonObject[1]?.latitude, jsonObject[1]?.longitude),
                            draggable: false,
                            map: mapAlert,
                            icon: {
                                url: agentIconColor
                            },
                        });
                        this.agentMarkersList.push(agentMarker);
                        this.agentMarkersList[this.agentMarkersList.length - 1].setMap(mapAlert);
    
                        agentMarker = new google.maps.Marker({
                            position: new google.maps.LatLng(jsonObject[1]?.latitude, jsonObject[1]?.longitude),
                            draggable: false,
                            map: mapAlert,
                            icon: {
                                url: "https://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                            },
                        });
                        this.agentCurrentPosition.push(agentMarker);
                        this.agentCurrentPosition[0].setMap(mapAlert);
                        if(this.agentLatLngList.length > 1){
                            this.agentLinePath = new google.maps.Polyline({
                                path: [this.agentLatLngList[this.agentLatLngList.length - 2],this.agentLatLngList[this.agentLatLngList.length - 1]],
                                map: mapAlert,
                                geodesic: true,
                                strokeColor: 'black'
                            });
                            this.agentLineList.push(this.agentLinePath)
                            this.agentLineList[this.agentLineList.length - 1].setMap(mapAlert);
                        }
                    }   
                },
                error => {
                    this.functionsService.errorHandler(error["status"]);
                }
            );
        },15000);
    }
    this.spinner.hide();
  }

  recenter_map(latitude, longitude) {
    const position = new google.maps.LatLng(Number.parseFloat(latitude),
        Number.parseFloat(longitude));
    mapAlert.panTo(position);
  }
  
  attendAlert(resolvedType) {
    this.spinner.show();
    this.apiService.getStatus(this.selectedAlert.id).subscribe(
        async data => {
            if(data["status"] != 0 && data["status"] != 3)
            {
                document.getElementById("alert-log").hidden = false;
                this.selectedAlert["attendedByName"] = data["attendedByName"];
                this.alertService.alertStatus = data["status"];
                switch(data["status"]){
                    case 1: 
                        var modalRef = this.modalService.open(StatusModalComponent, { size: 'lg', scrollable: true });
                        modalRef.componentInstance.title = this.translate.instant('alert.alert_update');
                        modalRef.componentInstance.message = this.translate.instant("alert.swa_content") + data["attendedByName"] + "."; 
                        this.router.navigateByUrl('/main/activeAlerts');
                        break;
                    case 2:
                    case 4:
                        if(data["attendedBy"] != this.userId)
                            {
                            if(document.getElementById("attend#"+this.selectedAlert?.id)){document.getElementById("attend#"+this.selectedAlert?.id).hidden = true;}
                            var modalRef = this.modalService.open(StatusModalComponent, { size: 'lg', scrollable: true });
                            modalRef.componentInstance.title = this.translate.instant('alert.alert_update');
                            modalRef.componentInstance.message = this.translate.instant("alert.sba_content") + data["attendedByName"] + "."; 
                        }
                        if(resolvedType!="pr"){
                            this.resolveAlert(resolvedType);
                        }
                        break; 
                    default: 
                        this.resolveAlert(resolvedType);
                        break;
                }
            }
            else{
                this.resolveAlert(resolvedType);
            }
            this.spinner.hide();
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        }
    );
  }

  confirmClosePrompt(resolvedType){
    const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
    confirmModalRef.componentInstance.title = this.translate.instant('alert.'+resolvedType);
    confirmModalRef.componentInstance.message = this.translate.instant('alert.close_alert_prompt')+this.translate.instant('alert.'+resolvedType)+"?";
    confirmModalRef.result.then(confirmed => {
        if (confirmed) {
            this.attendAlert(resolvedType);
        }
    });
  }

  resolveAlert(resolvedType) {
    this.spinner.show();
    var falsePositive = (resolvedType == 'false_alert') ? 1 : 0;
    var offZone = (resolvedType == 'out_of_zone') ? 1 : (resolvedType == 'mark_out_zone' ? 2 : 0);
    var status = (resolvedType == 'pr') ? 2 : 1;
    this.apiService.updateAlert(this.selectedAlert.id, this.selectedAlert.createdBy, falsePositive, offZone, status).subscribe(
        data => {
            document.getElementById("alert-log").hidden = false;
            this.selectedAlert.attendedByName = data["attendedByName"];
            this.alertService.alertStatus = data["status"];
            this.selectedAlert["attendedBy"] = data["attendedBy"];
            if(status == 2){
                this.attending = true;
                this.fetchAlert(this.selectedAlert.id, true)
                this.spinner.hide();
            }else{
                this.spinner.hide();
                this.router.navigateByUrl('/main/activeAlerts');
            }
        },
        error => {
            this.spinner.hide();
            this.functionsService.errorHandler(error["status"]);
        }
    )
  }

  addMessage(msg){
      this.user_msg = msg;
  }

  async sendMessage() {
      this.user_msg = this.user_msg.trim();
      if (this.user_msg) { // Send message to FireBase
        var userName = this.selectedAlert["attendedByName"];
        var topic = this.selectedAlert.organizationId + "-" + this.alertCreatedBy + "-" + this.selectedAlert.id;
        this.chatService.sendMessage(this.user_msg, this.alertCreatedBy, userName, this.conversationId, this.chatMessages ? true : false, 0);
        var message = {
            "message":{
                "topic": topic,
                "notification": {
                    "title": "Contigo",
                    "body": userName + ": " + this.user_msg
                },
                "data": {
                    "title": "",
                    "message": userName + ": " + this.user_msg,
                },
                "android": {
                    "notification": {
                        "title": "Contigo",
                        "body": userName + ": " + this.user_msg
                    }
                },
                "apns": {
                    "payload": {
                        "aps": {
                            "category": "NEW_MESSAGE_CATEGORY",
                            "alert": {
                                "title": "Contigo",
                                "body": userName + ": " + this.user_msg
                            },
                            "sound": "default",
                            "content-available": 1,
                            "mutable-content": 1
                        }
                    }
                }
            }
        }
        await this.apiService.getGoogleToken().subscribe(async token => {
            this.apiService.sendChatNotiFireBase(message,token).subscribe(data =>{
            console.log(data);
            });
        })
      }
      this.user_msg = '';
  }

  previewPDF(doc) {
    if(doc.name.slice(-3) == "pdf"){
        let tab = window.open();
        this.functionsService
        .previewPDF(doc.path)
        .subscribe(data => {
        const fileUrl = URL.createObjectURL(data);
        tab.location.href = fileUrl;
      });
    }
    else{
        this.functionsService.openImage(doc.path);
    }
  }

  viewAlertLog(alertId){
    window.open('/alertLog/'+alertId, '_blank', 'noopener');
  }

  reassignAlert(){
    const modalRef = this.modalService.open(ReassignAlertComponent, { size: 'lg' });
    modalRef.componentInstance.prevAttendedBy = this.selectedAlert.attendedBy;
    modalRef.componentInstance.getPossibleAttendees(this.selectedAlert.id);
    modalRef.result.then((data) => {
        this.selectedAlert = data?data:this.selectedAlert;
        this.chatService.sendMessage(this.selectedAlert["attendedBy"], this.selectedAlert["attendedByName"], this.alertCreatedBy, this.conversationId, this.chatMessages ? true : false, 3);
        this.fetchAlert(this.selectedAlert['id'], true);
    });
  }

  fetchAlertTypes() {
    this.apiService.getCustomAlertTypes(1).subscribe(resp => {
        this.alertTypes = resp;
        var types = [];
        let jsonString = JSON.stringify(resp);
        let jsonObject = JSON.parse(jsonString);
        jsonObject.forEach(element => {
            types.push(element.name);
        });
        
        if(!types.includes(this.selectedAlert.alertTypeName)){
            this.alertTypes[this.alertTypes.length] = {"id":this.selectedAlert.alertTypeId,"name":this.selectedAlert.alertTypeName,"color":this.selectedAlert.alertTypeColor};
        }
    }, err => {
        console.error(err);
        this.spinner.hide();
    });
  }

  changeType(event){
      if(event.target.value){
        this.spinner.show();
        this.apiService.changeAlertType({"Id":this.selectedAlert.id,"AlertTypeId":event.target.value, "AlertType":this.alertTypeName}).subscribe(
        data => {
                this.selectedAlert.AlertTypeId = event.target.value;
                this.selectedAlert.alertTypeName = data["name"];
                this.selectedAlert.alertTypeColor = data["color"];
                this.alertTypeName = this.selectedAlert.alertTypeName;
                this.fetchAlertTypes();
                if(this.functionsService.HEXToIntColor(this.selectedAlert["alertTypeColor"])){
                    this.textColor = "text-white";
                }else{ 
                    this.textColor = "text-dark";
                }
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                event.target.value = this.selectedAlert["alertTypeName"];
                this.functionsService.errorHandler(error["status"]);
            }
        );
      }
  }

  getUserFields() {    
    this.apiService.getFieldsName(this.profile['userId']).subscribe(
        data =>{
                this.c_fields = data;
                },
                error => {
                    this.functionsService.errorHandler(error["status"]);
                    this.spinner.hide();
                    }
                )
            }

getUserFieldOption() {
    this.apiService.getUserFieldOption().subscribe(
        data => {
          if(data["userFieldOption"] == "YES"){
            this.fieldOption = true;
          }
        },
        error => {
            this.fieldOption = false;
            this.spinner.hide();
        }
    );
  }
  ngOnDestroy(){
    clearInterval(this.timer);
    clearInterval(this.alertTimer);
    if(this.unsubscribe){this.unsubscribe.unsubscribe()};
    }

    loadAggressors(participantId: string): void {
        
        if (participantId) {
            this.apiService.getAggressorsByParticipant(participantId).subscribe({
                next: (data) => {
                    this.aggressors = data;
                },
                error: (error) => {
                    console.error('Error loading aggressors:', error);
                    this.aggressors = [];
                }
            });
        }
    }
    
    openAggressorModal(aggressor: any): void {
        this.selectedAggressor = aggressor;
        this.modalService.open(this.aggressorDetailsModal, {
            centered: true,
            size: 'lg',
            backdrop: 'static'
        });
    }
    
    getStatusText(status: number): string {
        switch (status) {
            case 1: return 'Activo';
            case 2: return 'Por Vencer';
            case 3: return 'Vencido';
            case 4: return 'Cancelado';
            case 5: return 'Pendiente';
            default: return 'Desconocido';
        }
    }
    
    onImageError(event: any): void {
        event.target.src = 'assets/images/default-aggressor.png';
    }



    
}

function initMap(data){
    geofence = new Geofence(mapProperties);

    data.forEach(zone => {
        geofence.drawStatic(zone["zonePositions"],mapProperties);
    });
    mapAlert = geofence.map;
}
